import utils, { RouterPath } from "./services/utils";
import session from "./services/session";

const MainView = () => import("./views/mainView.vue");
const Home = () => import("./views/home/home.vue");


const CategoryProductsPage = () => import("./views/productSearchPages/categoryProductsPage.vue");
const DefaultSearchProductsPage = () => import("./views/productSearchPages/defaultSearchProductsPage.vue");
const CollectionProductsPage = () => import("./views/productSearchPages/collectionProductsPage.vue");

const AboutUs = () => import("./views/about/aboutUs.vue");
const Careers = () => import("./views/careers/careers.vue");
const CareerForm = () => import("./views/careers/careerForm.vue");
const Faq = () => import("./views/faq/faq.vue");
const Login = () => import("./views/auth/login/login.vue");
const NotFound = () => import("./views/notFound.vue");
const ProductDetails = () => import("./views/productDetails/productDetails.vue");
const Checkout = () => import("./views/checkout/checkout.vue");
const CheckoutSteps = () => import("./views/checkout/checkoutSteps/checkoutSteps.vue");
const OrderConfirmation = () => import("./views/checkout/checkoutSteps/orderConfirmation/orderConfirmation.vue");
const Events = () => import("./views/events/events.vue");
const RequestAssortment = () => import("./views/requestAssortment/requestAssortment.vue");

const ValueProps = () => import("./views/valueProps/valueProps.vue");
const BuyerPage = () => import("./views/valueProps/BuyerPage.vue");
const BrandPage = () => import("./views/valueProps/BrandPage.vue");
const Onboarding = () => import("./views/onboarding/onboarding.vue");
const ThankYouPage = () => import("./views/valueProps/ThankYouPage.vue");

const ApplyAsBrand = () => import("./views/applyAsBrand/applyAsBrand.vue");
const ApplyAsRetailer = () => import("./views/applyAsRetailer/applyAsRetailer.vue");
const Dashboard = () => import("./views/dashboard/dashboard.vue");
const Products = () => import("./views/dashboard/products/products.vue");
const Drafts = () => import("./views/dashboard/drafts/drafts.vue");
const DraftEdit = () => import("./views/dashboard/drafts/editDraft/EditDraft.vue");
const Brands = () => import("./views/dashboard/brand/brands.vue");
const Retailers = () => import("./views/dashboard/retailers/retailers.vue");
const RetailerDetails = () => import("./views/dashboard/retailers/retailerDetails/retailerDetails.vue");
const BrandApplications = () => import("./views/dashboard/applications/brandApplications/brandApplications.vue");
const RetailerApplications = () =>
  import("./views/dashboard/applications/retailerApplications/retailerApplications.vue");
const CreateEditProduct = () => import("./views/dashboard/products/createEditProduct/createEditProduct.vue");
const CreateEditBrand = () => import("./views/dashboard/brand/createEditBrand/createEditBrand.vue");
const Collections = () => import("./views/dashboard/collections/collections.vue");
const DashboardHomepage = () => import("./views/dashboard/contentManagment/contentManagment.vue");
const Categories = () => import("./views/dashboard/categories/categories.vue");
const BrandDirectoryPage = () => import("./views/brandDirectoryPage/brandDirectoryPage.vue");
const BrandBio = () => import("./views/brandBio/brandBio.vue");
const RetailerProfile = () => import("./views/brandBio/retailerProfilePage/retailerProfilePage.vue");
const CreateEditCategory = () => import("./views/dashboard/categories/createEditCategory/createEditCategory.vue");
const CreateEditCollection = () =>
  import("./views/dashboard/collections/createEditCollection/createEditCollection.vue");
const Orders = () => import("./views/dashboard/orders/orders.vue");
const OrdersRetailer = () => import("./views/dashboard/orders/ordersRetailer/ordersRetailer.vue");
const Invoices = () => import("./views/dashboard/invoices/invoices.vue");
const Payments = () => import("./views/dashboard/payments/payments.vue");
const PaymentDetails = () => import("./views/dashboard/payments/paymentDetails/paymentDetails.vue");
const InvoiceDetails = () => import("./views/dashboard/invoices/invoiceDetails.vue");
const Favorites = () => import("./views/dashboard/favorites/favorites.vue");
const FavoritesList = () => import("./views/dashboard/favorites/favoritesList.vue");
const Messages = () => import("./views/dashboard/messages/messages.vue");
const ReturnDetails = () => import("./views/dashboard/returns/returnDetails/returnDetails.vue");
const AdminReturnDetails = () => import("./views/dashboard/returns/adminReturnDetails/adminReturnDetails.vue");
const OrderDetails = () => import("./views/dashboard/orders/orderDetails/orderDetails.vue");
const OrderDetailsRetailer = () => import("./views/dashboard/orders/orderDetails/orderDetailsRetailer.vue");
const createReviewPackingSlip = () =>
  import("./views/dashboard/orders/createReviewPackingSlip/createReviewPackingSlip.vue");
const createReviewReturnSlip = () =>
  import("./views/dashboard/returns/createReviewReturnSlip/createReviewReturnSlip.vue");
const CustomAssortments = () => import("./views/dashboard/customAssortments/customAssortments.vue");
const ConnectToStripe = () => import("./views/dashboard/brand/connectToStripe/connectToStripe.vue");
const AddCardInfo = () => import("./views/checkout/checkoutSteps/addCardInfo/addCardInfo.vue");
const SetPassword = () => import("./views/auth/setPassword/setPassword.vue");
const ForgotPassword = () => import("./views/auth/forgotPassword/forgotPassword.vue");
const Refer = () => import("./views/refer/refer.vue");
const Referrals = () => import("./views/dashboard/referrals/referrals.vue");
const Reorder = () => import("./views/dashboard/reorder/reorder.vue");
const Password = () => import("./views/dashboard/password/password.vue");
const Profile = () => import("./views/dashboard/profile/profile.vue");
const AdminPromoCodes = () => import("./views/dashboard/promoCodes/admin/adminPromoCodes.vue");
const BrandPromoCodes = () => import("./views/dashboard/promoCodes/brand/brandPromoCodes.vue");
const Addresses = () => import("./views/dashboard/addresses/addresses.vue");
const CreateEditAddress = () => import("./views/dashboard/addresses/createEditAddress/createEditAddress.vue");
const PaymentInfo = () => import("./views/dashboard/paymentInfo/paymentInfo.vue");

const Privacy = () => import("./views/static/privacy.vue");
const Terms = () => import("./views/static/terms.vue");
const ServiceFeePage = () => import("./views/static/service-fee-page.vue");
const CommercialTerms = () => import("./views/static/commercial-terms.vue");
const Copyright = () => import("./views/static/copyright.vue");

const Support = () => import("./views/home/support-the-stores/support-the-stores.vue");
const SummerShowcase = () => import("./views/home/summer-showcase/summer-showcase.vue");
const HolidayLanding = () => import("./views/home/holiday-landing.vue");
const VWOLanding = () => import("./views/home/vwo-landing-page");
const WinterShowcase = () => import("./views/home/winter-showcase/winter-showcase.vue");
const WinterShowcaseDir = () => import("./views/home/winter-showcase-brand-directory/winter-showcase.vue");

const TheDiscoveryFeed = () => import("./views/TheDiscoveryFeed/TheDiscoveryFeed.vue");
const Post = () => import("./views/TheDiscoveryFeed/Post");
const TheCreatePostPage = () => import("./views/TheDiscoveryFeed/TheCreatePostPage/TheCreatePostPage.vue");
const TheDashboardPostsPage = () => import("./views/dashboard/posts/TheDashboardPostsPage.vue");
const ConnectShopify = () => import("./views/dashboard/connectShopify/connectShopify.vue");
const ShopifyConnectStart = () => import("./views/shopifyConnectStart/shopifyConnectStart.vue");
const Sandbox = () => import("./views/sandbox/sandbox.vue");
const SandboxTextField = () => import("./views/sandbox/sandboxTextField.vue");
const SandboxButton = () => import("./views/sandbox/sandboxButton.vue");
const SandboxAddress = () => import("./views/sandbox/sandboxAddress.vue");
const SandboxFilters = () => import("./views/sandbox/sandboxFilters.vue");

const routes = [
  {
    path: "/",
    component: MainView,
    redirect: "/",
    children: [
      {
        path: "/dashboard",
        component: Dashboard,
        redirect: "/dashboard/products",
        meta: {
          title: "Dashboard",
          isPublic: false,
          roles: ["ADMIN"],
        },
        children: [
          {
            path: "/dashboard/referrals",
            component: Referrals,
            name: "dashboardReferrals",
            meta: {
              title: "Referrals",
              isPublic: false,
              roles: ["ADMIN", "BRAND"],
            },
          },
          {
            path: "/dashboard/referrals/new",
            component: Refer,
            name: "dashboardCreateReferral",
            meta: {
              title: "Refer a Retailer",
              isPublic: false,
              roles: ["BRAND"],
            },
          },
          {
            path: "/dashboard/products",
            component: Products,
            name: "dashboardProducts",
            meta: {
              title: "Dashboard Products",
              isPublic: false,
              roles: ["ADMIN", "BRAND", "PRODUCT_BUILDER"],
            },
          },
          {
            path: "/dashboard/products/new",
            component: CreateEditProduct,
            name: "createProduct",
            meta: {
              title: "New Product",
              isPublic: false,
              roles: ["ADMIN", "BRAND", "PRODUCT_BUILDER"],
            },
          },
          {
            path: "/dashboard/products/:productId/edit",
            component: CreateEditProduct,
            name: "editProduct",
            meta: {
              title: "Edit Product",
              isPublic: false,
              roles: ["ADMIN", "BRAND", "PRODUCT_BUILDER"],
            },
          },
          {
            path: "/dashboard/for-review",
            component: Drafts,
            name: "dashboardDrafts",
            meta: {
              title: "Dashboard Drafts",
              isPublic: false,
              roles: ["BRAND", "PRODUCT_BUILDER", "ADMIN"],
            },
          },
          {
            path: "/dashboard/drafts/:productId",
            component: DraftEdit,
            name: "dashboardDraftEdit",
            meta: {
              title: "Edit Draft",
              isPublic: false,
              roles: ["BRAND", "ADMIN", "PRODUCT_BUILDER"],
            },
          },
          // {
          // 	path: '/dashboard/categories',
          // 	component: Categories,
          // 	name: 'dashboardCategories',
          // 	meta: {
          // 		title: 'Categories',
          // 		isPublic: false,
          // 		roles: ['ADMIN']
          // 	}
          // },
          // {
          // 	path: '/dashboard/categories/:categoryId/edit',
          // 	component: CreateEditCategory,
          // 	name: 'editCategory',
          // 	meta: {
          // 		title: 'Edit Category',
          // 		isPublic: false,
          // 		roles: ['ADMIN']
          // 	}
          // },
          {
            path: "/dashboard/collections",
            component: Collections,
            name: "dashboardCollections",
            meta: {
              title: "Collections",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/dashboard/collections/:id/edit",
            component: CreateEditCollection,
            name: "editCollection",
            meta: {
              title: "Edit Collection",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/dashboard/collections/new",
            component: CreateEditCollection,
            name: "createCollection",
            meta: {
              title: "New Collection",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/dashboard/content-management",
            component: DashboardHomepage,
            name: "dashboardHomepage",
            meta: {
              title: "Content Management",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/dashboard/brands",
            component: Brands,
            name: "dashboardBrands",
            meta: {
              title: "Dashboard Brands",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/dashboard/retailers",
            component: Retailers,
            name: "dashboardRetailers",
            meta: {
              title: "Dashboard Retailers",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/dashboard/retailers/:id",
            component: RetailerDetails,
            name: "Retailer Details",
            meta: {
              title: "Account Settings - Profile",
              isPublic: false,
              roles: ["ADMIN", "RETAILER"],
            },
          },
          {
            path: "/dashboard/favorites",
            component: Favorites,
            name: "dashboardFavorites",
            meta: {
              title: "Dashboard favorites",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/favorites/by-product",
            component: FavoritesList,
            name: "dashboardFavoritesProduct",
            meta: {
              title: "bp",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/favorites/by-brand",
            component: FavoritesList,
            name: "dashboardFavoritesBrand",
            meta: {
              title: "bb",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/favorites/recommendations",
            component: FavoritesList,
            name: "dashboardFavoritesRecommendation",
            meta: {
              title: "bb",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/messages",
            component: Messages,
            name: "dashboardMessages",
            meta: {
              title: "Messages",
              isPublic: false,
              roles: ["RETAILER", "BRAND"],
            },
          },
          {
            path: "/dashboard/applications/brands",
            component: BrandApplications,
            name: "dashboardBrandApplications",
            meta: {
              title: "Dashboard Brand Applications",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/dashboard/applications/retailers",
            component: RetailerApplications,
            name: "dashboardRetailerApplications",
            meta: {
              title: "Dashboard Retailer Applications",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/dashboard/brands/new",
            component: CreateEditBrand,
            name: "createBrand",
            meta: {
              title: "Create Brand",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/dashboard/brands/:brandId/edit",
            component: CreateEditBrand,
            name: "editBrand",
            meta: {
              title: "Edit Brand",
              isPublic: false,
              roles: ["ADMIN", "BRAND"],
            },
          },
          {
            path: "/dashboard/brands/my-brand-page",
            component: CreateEditBrand,
            name: "my-brand-page",
            meta: {
              title: "Edit My Brand Page",
              isPublic: false,
              roles: ["BRAND"],
            },
          },
          {
            path: "/dashboard/reorder",
            component: Reorder,
            name: "reorder",
            meta: {
              title: "Dashboard Reorder",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/returns/:returnId",
            component: AdminReturnDetails,
            name: "adminReturnDetails",
            meta: {
              title: "Dashboard Admin Return Details",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/dashboard/returns/:orderId/details",
            component: ReturnDetails,
            name: "returnDetails",
            meta: {
              title: "Dashboard Return Details",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/returns/:orderId/create-return-slip",
            component: createReviewReturnSlip,
            name: "createReturnSlip",
            meta: {
              title: "Dashboard Create Return Slip",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/returns/:orderId/review-return-slip/:returnSlipId/details",
            component: createReviewReturnSlip,
            name: "reviewReturnSlip",
            meta: {
              title: "Dashboard Review Return Slip",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/orders",
            component: Orders,
            name: "orders",
            meta: {
              title: "Dashboard Orders",
              isPublic: false,
              roles: ["ADMIN", "BRAND", "RETAILER"],
            },
          },
          {
            path: "/dashboard/retailer/orders",
            component: OrdersRetailer,
            name: "ordersRetailer",
            meta: {
              title: "Dashboard Orders",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/orders/:orderId/details",
            component: OrderDetails,
            name: "orderDetails",
            meta: {
              title: "Dashboard Order Details",
              isPublic: false,
              roles: ["ADMIN", "BRAND", "RETAILER"],
            },
            beforeEnter: (to, from, next) => {
              if (session.getUserInfo().role === "RETAILER") {
                return next({
                  name: "orderDetailsRetailer",
                  params: {
                    orderId: to.params.orderId,
                  },
                });
              }

              next();
            },
          },
          {
            path: "/dashboard/retailer/orders/:orderId/details",
            component: OrderDetailsRetailer,
            name: "orderDetailsRetailer",
            meta: {
              title: "Dashboard Order Details",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/orders/:suborderId",
            component: OrderDetails,
            name: "suborderDetails",
            meta: {
              title: "Dashboard Suborder Details",
              isPublic: false,
              roles: ["ADMIN", "BRAND", "RETAILER"],
            },
          },
          {
            path: "/dashboard/orders/:id/create-packing-slip",
            component: createReviewPackingSlip,
            name: "createPackingSlip",
            meta: {
              title: "Dashboard Suborder Details",
              isPublic: false,
              roles: ["ADMIN", "BRAND"],
            },
          },
          {
            path: "/dashboard/orders/:id/packingSlips/:packingSlipId/review-packing-slip",
            component: createReviewPackingSlip,
            name: "reviewPackingSlip",
            meta: {
              title: "Dashboard Suborder Details",
              isPublic: false,
              roles: ["ADMIN", "BRAND"],
            },
          },
          {
            path: "/dashboard/invoices",
            component: Invoices,
            name: "invoices",
            meta: {
              title: "Dashboard Invoices",
              isPublic: false,
              roles: ["RETAILER", "ADMIN"],
            },
          },
          {
            path: "/dashboard/invoices/:invoiceId/details/:retailerId",
            component: InvoiceDetails,
            name: "invoiceDetails",
            meta: {
              title: "Dashboard Invoice Details",
              isPublic: false,
              roles: ["RETAILER", "ADMIN"],
            },
          },
          {
            path: "/dashboard/payments",
            component: Payments,
            name: "payments",
            meta: {
              title: "Dashboard Payments",
              isPublic: false,
              roles: ["ADMIN", "BRAND"],
            },
          },
          {
            path: "/dashboard/payments/:suborderId/details",
            component: PaymentDetails,
            name: "paymentDetails",
            meta: {
              title: "Dashboard Payment Details",
              isPublic: false,
              roles: ["ADMIN", "BRAND"],
            },
          },
          {
            path: "/dashboard/custom-assortments",
            component: CustomAssortments,
            name: "customAssortments",
            meta: {
              title: "Dashboard Custom Assortments",
              isPublic: false,
              roles: ["ADMIN", "RETAILER"],
            },
          },
          {
            path: "/dashboard/profile/:id?",
            component: Profile,
            name: "dashboardProfile",
            meta: {
              title: "Account Settings - Profile",
              isPublic: false,
              roles: ["ADMIN", "RETAILER"],
            },
          },
          {
            path: "/dashboard/password",
            component: Password,
            name: "dashboardPassword",
            meta: {
              title: "Account Settings - Password",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/admin-promo-codes",
            component: AdminPromoCodes,
            name: "dashboardAdminPromoCodes",
            meta: {
              title: "Promo Codes",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/dashboard/brand-promo-codes",
            component: BrandPromoCodes,
            name: "dashboardBrandPromoCodes",
            meta: {
              title: "Promo Codes",
              isPublic: false,
              roles: ["BRAND"],
            },
          },
          {
            path: "/dashboard/addresses",
            component: Addresses,
            name: "dashboardAddresses",
            meta: {
              title: "Account Settings - Addresses",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/addresses/new",
            component: CreateEditAddress,
            name: "dashboardCreateAddress",
            meta: {
              title: "Account Settings - Create Address",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/addresses/:id/edit",
            component: CreateEditAddress,
            name: "dashboardEditAddress",
            meta: {
              title: "Account Settings - Edit Address",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/payment-options",
            component: PaymentInfo,
            name: "dashboardPaymentInfo",
            meta: {
              title: "Account Settings - Payment Info",
              isPublic: false,
              roles: ["RETAILER"],
            },
          },
          {
            path: "/dashboard/posts",
            component: TheDashboardPostsPage,
            name: "dashboardPosts",
            meta: {
              title: "Bulletin Discovery Feed: My Posts",
              isPublic: false,
              roles: ["BRAND", "ADMIN"],
            },
          },
          {
            path: "/dashboard/connect-shopify",
            component: ConnectShopify,
            name: "connectShopify",
            meta: {
              title: "Connect Shopify",
              isPublic: false,
              roles: ["BRAND"],
            },
          },
        ],
      },
      {
        path: "/",
        component: Home,
        name: "home",
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/terms",
        name: "terms",
        component: Terms,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/service-fee",
        name: "service-fee",
        component: ServiceFeePage,
        meta: {
          isPublic: true,
        },
      },

      {
        path: "/commercial-terms",
        name: "commercial-terms",
        component: CommercialTerms,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/privacy",
        name: "privacy",
        component: Privacy,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/copyright-policy",
        name: "copyright",
        component: Copyright,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/home",
        name: "home",
        component: Home,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/support-the-stores",
        name: "support-the-stores",
        component: Support,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/summer-showcase",
        name: "summerShowcase",
        component: SummerShowcase,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/high-sell-through",
        name: "highSellThrough",
        component: SummerShowcase,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/stocked-for-the-season",
        name: "stockedForTheSeason",
        component: HolidayLanding,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/exclusive",
        name: "vwoLandingPage",
        component: VWOLanding,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/virtual-discovery-show",
        name: "winterShowcase",
        component: WinterShowcase,
        meta: {
          isPublic: true,
          keepScrollPosition: true,
        },
      },
      {
        path: "/virtual-discovery-show-brand-directory",
        name: "winterShowcaseDirectory",
        component: WinterShowcaseDir,
        meta: {
          isPublic: true,
          keepScrollPosition: false,
        },
      },
      {
        path: "/products/:productName/:productId",
        component: ProductDetails,
        name: "productDetails",
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/brands",
        name: "brands",
        component: BrandDirectoryPage,
        meta: {
          title: "brands",
          isPublic: true,
        },
      },
      {
        path: `/${RouterPath.DEFAULT_SEARCH_PRODUCT_PAGE}`,
        name: "search",
        component: DefaultSearchProductsPage,
        meta: {
          title: "Search",
          isPublic: true,
        },
      },
      {
        path: `/${RouterPath.COLLECTION_PRODUCTS_PAGE}/:collectionName/:collectionId`,
        name: "Collection",
        component: CollectionProductsPage,
        meta: {
          isPublic: true,
        },
        props: {
          fromNavBar: false,
        },
      },
      {
        path: `/:navItemParentName?/:navItemName/:navItemId/${RouterPath.CATEGORY_PRODUCTS_PAGE}`,
        name: "productsFromNavigation",
        component: CategoryProductsPage,
        meta: {
          isPublic: true,
        },
      },
      {
        path: `/:categoryName/:collectionName/:collectionId/${RouterPath.COLLECTION_PRODUCTS_PAGE}`,
        name: "CollectionWithCategory",
        component: CollectionProductsPage,
        meta: {
          isPublic: true,
        },
        props: {
          fromNavBar: true,
          isParentCollection: false,
        },
      },
      {
        path: `/:collectionName/:collectionId/${RouterPath.COLLECTION_PRODUCTS_PAGE}`,
        name: "ParentCollection",
        component: CollectionProductsPage,
        meta: {
          isPublic: true,
        },
        props: {
          isParentCollection: true,
          fromNavBar: true,
        },
      },
      {
        path: `/${RouterPath.COLLECTION_PRODUCTS_PAGE}/:collectionName/:collectionId`,
        name: "Collection",
        component: CollectionProductsPage,
        meta: {
          isPublic: true,
        },
        props: {
          fromNavBar: false,
          isParentCollection: false,
        },
      },
      {
        path: `/category/:categoryId/:categoryHandle/products/:productId/:productHandle`,
        component: ProductDetails,
        name: "categoryProductDetails",
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/about",
        name: "about",
        component: AboutUs,
        meta: {
          title: "About",
          isPublic: true,
        },
      },
      {
        path: "/checkout",
        name: "checkout",
        component: Checkout,
        meta: {
          title: "Checkout",
          isPublic: true,
        },
      },
      {
        path: "/checkout/shipping",
        name: "checkoutShipping",
        component: CheckoutSteps,
        meta: {
          title: "Shipping",
          isPublic: false,
          roles: ["ADMIN", "RETAILER"],
        },
      },
      {
        path: "/checkout/order-review",
        name: "checkoutOrderReview",
        component: CheckoutSteps,
        meta: {
          title: "Order Details",
          isPublic: false,
          roles: ["ADMIN", "RETAILER"],
        },
      },
      {
        path: "/checkout/payment",
        name: "checkoutAddCardInfo",
        component: CheckoutSteps,
        meta: {
          title: "Payment",
          isPublic: false,
          roles: ["ADMIN", "RETAILER"],
        },
      },
      {
        path: "/checkout/order-confirmation/:id",
        name: "orderConfirmation",
        component: OrderConfirmation,
        meta: {
          title: "Order Confirmation",
          isPublic: false,
          roles: ["ADMIN", "RETAILER"],
        },
      },
      {
        path: "/careers",
        component: Careers,
        meta: {
          title: "Careers",
          isPublic: true,
        },
      },
      {
        path: "/career-form/:jobId",
        component: CareerForm,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/sign-in",
        name: "signIn",
        component: Login,
        meta: {
          title: "Sign In",
          isPublic: true,
        },
      },
      {
        path: "/set-password",
        name: "setPassword",
        component: SetPassword,
        meta: {
          title: "Set Password",
          isPublic: true,
        },
      },
      {
        path: "/forgot-password",
        name: "forgotPassword",
        component: ForgotPassword,
        meta: {
          title: "Forgot Password",
          isPublic: true,
        },
      },
      {
        path: "/faq/:page?",
        name: "faq",
        component: Faq,
        meta: {
          title: "FAQ",
          isPublic: true,
        },
        beforeEnter() {
          window.location.replace(utils.constants.ZENDESK_URL);
        },
      },
      {
        path: "/events/:eventId?",
        name: "events",
        component: Events,
        meta: {
          title: "Events",
          isPublic: true,
        },
      },
      {
        path: "/request-assortment",
        name: "request-assortment",
        component: RequestAssortment,
        meta: {
          title: "Request Assortment",
          isPublic: true,
        },
      },
      {
        path: "/value-props/:view?",
        name: "value-props",
        component: ValueProps,
        meta: {
          title: "Value Props",
          isPublic: true,
        },
      },
      {
        path: "/wholesale-retail/buyer",
        name: "buyer",
        component: BuyerPage,
        meta: {
          title: "Buyer Page",
          isPublic: true,
        },
      },
      {
        path: "/wholesale-retail/buyer-adwords",
        name: "buyer-adwords",
        component: BuyerPage,
        meta: {
          title: "Buyer Page",
          isPublic: true,
        },
      },
      {
        path: "/wholesale-retail/buyer-linkedin",
        name: "buyer-linkedin",
        component: BuyerPage,
        meta: {
          title: "Buyer Page",
          isPublic: true,
        },
      },
      {
        path: "/wholesale-retail/buyer-instagram",
        name: "buyer-instagram",
        component: BuyerPage,
        meta: {
          title: "Buyer Page",
          isPublic: true,
        },
      },
      {
        path: "/wholesale-retail/buyer-facebook",
        name: "buyer-facebook",
        component: BuyerPage,
        meta: {
          title: "Buyer Page",
          isPublic: true,
        },
      },
      {
        path: "/wholesale-retail/buyer-email",
        name: "buyer-email",
        component: BuyerPage,
        meta: {
          title: "Buyer Page",
          isPublic: true,
        },
      },
      {
        path: "/wholesale-retail/buyer-partner",
        name: "buyer-partner",
        component: BuyerPage,
        meta: {
          title: "Buyer Page",
          isPublic: true,
        },
      },
      {
        path: "/wholesale-retail/brand",
        name: "Brand",
        component: BrandPage,
        meta: {
          title: "Brand Page",
          isPublic: true,
        },
      },
      {
        path: "/thank-you",
        name: "thank you",
        component: ThankYouPage,
        meta: {
          title: "Thank You!",
          isPublic: true,
        },
      },
      {
        path: "/brands/:brandUrl",
        name: "brand-bio",
        component: BrandBio,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/retailer/:id",
        name: "retailer-profile",
        component: RetailerProfile,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/retailer",
        name: "retailer-profile",
        component: RetailerProfile,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/apply-as-brand",
        name: "apply-as-brand",
        component: ApplyAsBrand,
        meta: {
          title: "Apply As Brand",
          isPublic: true,
        },
      },
      {
        path: "/apply-as-retailer",
        name: "apply-as-retailer",
        component: ApplyAsRetailer,
        meta: {
          title: "Apply As Retailer",
          isPublic: true,
        },
      },
      {
        path: "/onboarding",
        name: "onboarding",
        component: Onboarding,
        meta: {
          title: "Onboarding",
          isPublic: true,
        },
      },
      {
        path: "/:orderId/add-card-info",
        component: AddCardInfo,
        name: "addCardInfo",
        meta: {
          title: "Add Card Info",
          isPublic: false,
          roles: ["RETAILER"],
        },
      },
      {
        path: "/connect-to-stripe",
        component: ConnectToStripe,
        name: "connectToStripe",
        meta: {
          title: "Connect to Stripe",
          isPublic: true,
        },
      },
      {
        path: "/refer",
        component: Refer,
        name: "refer",
        meta: {
          title: "Refer a Retailer",
          isPublic: false,
          roles: ["BRAND"],
        },
      },
      {
        path: "/plus",
        component: TheDiscoveryFeed,
        name: "TheDiscoveryFeed",
        meta: {
          title: "Bulletin Discovery Feed",
          isPublic: false,
          roles: ["BRAND", "ADMIN", "RETAILER"],
        },
      },
      {
        path: "/plus/posts/:id",
        component: Post,
        name: "SinglePost",
        meta: {
          title: "Bulletin Plus Post",
          isPublic: true,
        },
      },
      {
        path: "/plus/create-post",
        component: TheCreatePostPage,
        name: "TheCreatePostPage",
        meta: {
          title: "Bulletin Discovery Feed: Create Post",
          isPublic: false,
          roles: ["BRAND", "ADMIN", "RETAILER"],
        },
      },
      {
        path: "/shopify-connect",
        component: ShopifyConnectStart,
        name: "ShopifyConnectStart",
        meta: {
          title: "Bulletin Shopify Connection",
          isPublic: true,
        },
      },
      {
        path: "/sandbox",
        component: Sandbox,
        name: "sandbox",
        redirect: "/sandbox/text-field",
        meta: {
          title: "Component Sandbox",
          isPublic: false,
          roles: ["ADMIN"],
        },
        children: [
          {
            path: "/sandbox/text-field",
            component: SandboxTextField,
            name: "sandboxTextField",
            meta: {
              title: "TextField",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/sandbox/button",
            component: SandboxButton,
            name: "sandboxButton",
            meta: {
              title: "Button",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/sandbox/address",
            component: SandboxAddress,
            name: "sandboxAddress",
            meta: {
              title: "Address",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
          {
            path: "/sandbox/filters",
            component: SandboxFilters,
            name: "sandboxFilters",
            meta: {
              title: "Filters",
              isPublic: false,
              roles: ["ADMIN"],
            },
          },
        ],
      },
      {
        path: "*",
        name: "notFound",
        component: NotFound,
        meta: {
          isPublic: true,
        },
      },
    ],
  },
];

export default routes;
